import PhoneMixin from '@/Mixins/BaseInformation/PhoneMixin';
import NotificationMixin from '@/Mixins/800/notification/notification.mixin';
import SharedHelper from '@/Helpers/Shared';
export default {
  data() {
    return {
      addOrUpdateForm: {
        expirationDate: null,
        text: '',
        phoneIds: [],
      },
      searchAllCodesText: '',
      title: '',
      searchAddedCodesText: '',
      addedCodes: [],
      formValidationFields: {
        text: '',
        expirationDate: '',
        phoneIds: '',
      },
    };
  },
  mixins: [PhoneMixin, SharedHelper, NotificationMixin],
  methods: {
    toggleAddCode: function (id) {
      if (this.haveAlreadyAdded(id)) this.deleteAddedCode(id);
      else this.addNewCode(id);
    },
    haveAlreadyAdded: function (id) {
      return [...this.addedCodes]?.some((addedCode) => addedCode.id === id);
    },
    deleteAddedCode: function (id) {
      this.addedCodes = [...this.addedCodes]?.filter((addedCode) => addedCode.id !== id);
    },
    addNewCode: function (id) {
      const newCode = [...this.allPhones]?.find((code) => code.id === id);
      this.addedCodes = [...this.addedCodes, newCode];
    },
    initialAddedFetchedCodes: function () {
      this.addOrUpdateForm.phoneIds = [];
    },
    addNotification: function () {
      this.addOrUpdateForm.phoneIds = [...this.addedCodes].map(({ id }) => +id);
      const body = { ...this.addOrUpdateForm };
      if (this.validateForm()) {
        this.addNewNotification(body);
      }
    },
    editNotfication: function () {
      this.addOrUpdateForm.phoneIds = [...this.addedCodes].map(({ id }) => +id);
      const id = this.$route.query?.id;
      const body = { ...this.addOrUpdateForm, id };
      if (this.validateForm()) {
        this.editNotification(body);
      }
    },
    backToNotificationView: function () {
      this.$router.replace({ name: 'notification_for_800' });
    },
    validateForm: function () {
      if (!this.addOrUpdateForm.text) {
        this.showErrorAlert('توضحیات نمی تواند خالی باشد', 5000);
        return;
      }
      if (!this.addOrUpdateForm.expirationDate) {
        this.showErrorAlert('تاریخ اعتبار نمی تواند خالی باشد', 5000);
        return;
      }
      if (!this.addOrUpdateForm.phoneIds?.length) {
        this.showErrorAlert('حداقل یک کد نیاز به انتخاب دارد', 5000);
        return;
      }
      return true;
    },
    addAllCodes: function () {
      this.addedCodes = [...this.allPhones];
    },
    clearAllCodes: function () {
      this.addedCodes = [];
    },
    haveBeenAdded: function (id) {
      return [...this.addedCodes].some((phone) => phone?.id === id);
    },
  },
  computed: {
    filterdSelectedAddedCodes: function () {
      return [...this.addedCodes].filter(({ code }) => code?.includes(this.searchAddedCodesText));
    },
    filterdAllCodes: function () {
      return [...this.allPhones].filter(({ code }) => code.includes(this.searchAllCodesText));
    },
    isEditPage: function () {
      return !!this.$route.query?.id;
    },
  },
  watch: {
    '$store.state.userModule.successFlag': {
      handler: function (currentVal) {
        if (currentVal) this.getAllPhones();
      },
      immediate: true,
    },
    $route: {
      handler(route) {
        const id = route?.query?.id;
        this.title = id ? 'ویرایش اعلان' : 'افزودن اعلان جدید';
        if (id) {
          this.getNotification(id);
        }
      },
      immediate: true,
    },
    title: {
      handler(titleVal) {
        document.title = titleVal;
      },
      immediate: true,
    },
    notification: function (currentVal) {
      if (currentVal?.description) {
        this.addOrUpdateForm.text = currentVal?.description;
        this.addedCodes = currentVal?.noticePhones;
        this.addOrUpdateForm.expirationDate = currentVal?.isoExpirationDate;
      }
    },
  },
};
